import axios from "axios";

import { BASE_URL } from "./constants";
import { adminInfoGetterService, adminInfoRemovalService } from "./services";
const token = localStorage.getItem("obenev-token");

// const isStagingDomain = window.location.hostname === "portal.obenev.com";

// const BASEURL = isStagingDomain
//   ? "https://api.obenev.com"
//   : "https://api.obenelectric.com";

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// axiosInstance.interceptors.request.use(function (config) {
//   config.headers.Authorization = adminInfoGetterService();
//   return config;
// });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("obenev-token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      adminInfoRemovalService();
      window.location = "/";
    } else return Promise.reject(error);
  },
);
